<template>
  <q-checkbox v-if="displayHiddenColumnCheckbox" v-model="CommonHelper.displayHiddenColumns.value" title="Display Hidden Columns" dark keep-color color="white" />
</template>

<script>
import CommonHelper from "../helper/CommonHelper.js";
import { computed } from "vue";

export default {
  name: "HiddenColumnCheckbox",
  setup() {
    const displayHiddenColumnCheckbox = computed(() => {
      let returnValue = false;
      const scopeFields = CommonHelper.getScopeFields(CommonHelper.selectedSearchScopeOptions.value);

      if (scopeFields.length > 10 && CommonHelper.rowData.value.length > 0) {
        returnValue = true;
      }

      return returnValue;
    });

    return {
      //helpers
      CommonHelper,

      //variable properties
      displayHiddenColumnCheckbox
    };
  }
}
</script>